import React from 'react';

import * as List from 'components/list';
import { useCXI } from 'modules/cxi/useCXI';

import { Container } from '../container';
import * as Styled from './StyledSupport';

export const Support = () => {
    const { t } = useCXI();

    // Create the secondary actions options
    const sac = [
        {
            as: 'a',
            icon: 'fa fa-question-circle',
            href: 'https://helpme.openstartups.net/hc/pt-br',
            text: t('support.sac'),
        },
    ];
    const actions = [
        {
            as: 'a',
            icon: 'fab fa-whatsapp',
            href: 'https://wa.me/551135005001',
            text: t('support.whatsapp'),
        },
        {
            as: 'a',
            icon: `fa fa-envelope`,
            href: 'mailto:helpme@openstartups.net',
            text: t('support.email'),
        },
        {
            as: 'a',
            icon: 'fab fa-facebook-messenger',
            href: 'http://www.facebook.com/messages/t/1616610695217236',
            text: t('support.messenger'),
        },
    ];

    return (
        <Styled.Support as={Container.Slim}>
            <Container.Head>
                <span className="text">{t('menu.support')}</span>
            </Container.Head>

            <Container.Body>
                Caso o guia de uso não tenha sanado suas dúvidas, você pode visitar a nossa página
                de perguntas frequentes, onde buscamos responder algumas questões e oferecer
                soluções para os problemas mais comuns enfrentados por nossos usuários.
            </Container.Body>

            <Container.Feet>
                <List.List name="SupportList">
                    <List.Vertical items={sac} itemKey="icon" />
                </List.List>
                <p>
                    Se você está enfrentando algum tipo de erro ou bug que torne a sua experiência
                    menos agradável, mas não encontra a resposta na nossa página de perguntas
                    frequentes, selecione o canal da sua preferência ao clicar nos botões abaixo.{' '}
                </p>
                <p>
                    Identifique-se e reporte a dúvida ou onde, o que e como ocorre o erro ou bug
                    identificado. Sempre que possível, anexe o link da página ou imagens do trajeto
                    realizado e, principalmente, do erro ou bug propriamente dito.
                </p>
                <List.List name="SupportList">
                    <List.Vertical items={actions} itemKey="icon" />
                </List.List>
            </Container.Feet>
        </Styled.Support>
    );
};
